import { theme } from "antd";
import { orange, orangeDark, blue, blueDark, volcano, volcanoDark, generate } from "@ant-design/colors";

const baseGrey = "#bfbfbf";

const grey = generate(baseGrey);
const darkGrey = generate(baseGrey, { theme: "dark" });

const antdThemeLight = {
    token: {
        colorPrimary: orange.primary,
        colorInfo: blue.primary,
        colorWarning: volcano.primary,
        colorSuccess: orange.primary,

        controlHeight: 38,
        controlHeightLG: 44,
        controlHeightSM: 26,
    },
    components: {
        Layout: {
            headerBg: grey[0],
        },
        Menu: {
            iconSize: 18,
        },
    },
};

const antdThemeDark = {
    token: {
        colorPrimary: orangeDark.primary,
        colorInfo: blueDark.primary,
        colorWarning: volcanoDark.primary,
        colorSuccess: orangeDark.primary,

        controlHeight: 38,
        controlHeightLG: 44,
        controlHeightSM: 26,
    },
    algorithm: theme.darkAlgorithm,
    components: {
        Layout: {
            headerBg: darkGrey[0],
        },
        Menu: {
            iconSize: 18,
        },
    },
};

const styledThemeLight = {
    theme: "light",
    white: "#ffffff",
    purple: "#800080",
    orange: "#fe991c",
    red: "#FF4D4F",
    gray400: "#bfbfbf",
    inputBorder: "#d9d9d9",
    inputColor: "rgba(0, 0, 0, 0.85)",
    menuHoverBg: "rgba(0, 0, 0, .04)",
};

const styledThemeDark = {
    theme: "dark",
    white: "#1f1f1f",
    purple: "#d3adf7",
    orange: "#fe991c",
    red: "#FF4D4F",
    gray400: "#8c8c8c",
    inputBorder: "#434343",
    inputColor: "rgba(255, 255, 255, 0.85)",
    menuHoverBg: "rgba(255, 255, 255, .04)",
};

export const antdTheme = {
    light: antdThemeLight,
    dark: antdThemeDark,
};

export const styledTheme = {
    light: styledThemeLight,
    dark: styledThemeDark,
};

export { grey, darkGrey };
